var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app"},[(!_vm.isIE)?_c('main',{staticClass:"app-main"},[_c('router-view')],1):_c('PartsIE',{staticClass:"app-isIE"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }